import React from 'react';

import styles from './userSiteNotificationsPageStyles.scss';

import SiteNotificationSettingsContainer from 'buyside/components/container/UserAccount/SiteNotificationSettingsContainer';

const UserSiteNotificationsPage = (): React.ReactElement => (
  <>
    <div className={styles.pageTitle}>Site Notifications</div>
    <SiteNotificationSettingsContainer />
  </>
);

export default UserSiteNotificationsPage;
